import React from "react";

export const MosaicDishName: React.FC<{dishName: string}> = ({dishName}) => {
  return (
    <div className="text-white fixed  z-100 text-[15px] leading-[18px] mr-[12px] font-semibold relative">
      <p className="absolute left-[12px] bottom-[15px]">{dishName}</p>
    </div>
  );
};
